import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
	const btnSticky = document.querySelector('.sticky-add');
	const trigger = document.querySelector('section.product');
	const CLASS_VISIBLE = 'sticky-add--visible';

	if (btnSticky && trigger) {
		ScrollTrigger.create({
			trigger: trigger,
			start: "top top",
			bottom: "bottom top",

			onEnter: () => {
				btnSticky.classList.remove(CLASS_VISIBLE);
			},
			onEnterBack: () => {
				btnSticky.classList.remove(CLASS_VISIBLE);
			},
			onLeave: () => {
				btnSticky.classList.add(CLASS_VISIBLE);
			}
		});

		ScrollTrigger.matchMedia({
			"(max-width: 767px)": function() {
				const main = document.querySelector('main');
				ScrollTrigger.create({
					trigger: main,
					start: "bottom 50%",
					end: "+=2000",

					// onUpdate: (self) => {
					// 	console.log(self.progress);
					// },
					onEnter: () => {
						btnSticky.classList.remove(CLASS_VISIBLE);
					},
					onLeaveBack: () => {
						btnSticky.classList.add(CLASS_VISIBLE);
					},
				});
			}
		});
	}
}